import { render, staticRenderFns } from "./SaveUser.vue?vue&type=template&id=2b41ac8a&scoped=true"
import script from "./SaveUser.vue?vue&type=script&lang=js"
export * from "./SaveUser.vue?vue&type=script&lang=js"
import style0 from "./SaveUser.vue?vue&type=style&index=0&id=2b41ac8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b41ac8a",
  null
  
)

export default component.exports